<template>
  <v-row justify="center">
    <v-dialog
      v-model="value"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Изменение пароля пользователя</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <div class="d-flex align-start black--text">{{profile.USER_FIO}}</div>
            <div class="d-flex align-end"><v-spacer></v-spacer><small>{{profile.EMP_WTITLE}}</small></div>
            <v-divider></v-divider>
            <v-row class="mt-5">
              <v-col cols="12">
                <v-text-field
                  v-model="currPass"
                  label="Текущий пароль*"
                  type="password"
                  required dense
                  @keypress="checkCharcode"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="newPass"
                  label="Новый пароль*"
                  hint="Только латинские символы и цифры, спецсимволы не разрешены"
                  type="password"
                  persistent-hint
                  required dense
                  @keypress="checkCharcode"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="newPass_2"
                  label="Подтверждение нового пароля*"
                  hint="Повторите ввод нового пароля."
                  persistent-hint
                  type="password"
                  required dense
                  @keypress="checkCharcode"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <small>*Поля, обязательные для заполнения</small>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="blue darken-1"
            text
            @click="$emit('input', false)"
          >
            Отмена
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="onSaveEvent"
            :disabled="!isFormValid"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { ORG_SET_NEW_PWD } from '@/store/actions/org'
import { UI_SNACKBAR } from '@/store/actions/ui'

export default {
  name: 'sysChangePassForm',
  props: ['value'],
  components: {
  },
  data: () => ({
    currPass: '',
    newPass: '',
    newPass_2: ''
  }),
  computed: {
    profile: {
      get: function () {
        return this.$store.getters.getProfile
      }
    },
    isFormValid: {
      get: function () {
        return this.currPass.trim() && this.newPass.trim() && this.newPass.trim() === this.newPass_2.trim()
      }
    }
  },
  methods: {
    clearForm () {
      this.currPass = ''
      this.newPass = ''
      this.newPass_2 = ''
    },
    onSuccess (data) {
      this.clearForm()
      this.$emit('onSuccess')
    },
    onSaveEvent () {
      // Сохраняем данные
      const passParams = {
        OLD_PASS: this.currPass,
        NEW_PASS: this.newPass,
        CONF_NEW_PASS: this.newPass_2
      }
      console.log('Saving passwords')
      this.$store.dispatch(ORG_SET_NEW_PWD, passParams)
        .then((resp) => {
          console.log('Saving new password finished success in changePassForm: ', resp)
          this.onSuccess(resp)
        })
        .catch((err) => {
          console.log('Ошибка ', err)
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка:' + err })
        })
    },
    checkCharcode (event) {
      const res = /^[a-zA-Z0-9]/.test(String.fromCharCode(event.charCode))
      if (!res) { event.preventDefault() }
    }
  }

}
</script>
